import React from "react";
import { MDBBtn } from "mdb-react-ui-kit";
import {
  availableMarketplaces,
  upcomingMarketplaces,
} from "./constants";
import PoshmarkDetails from "./PoshmarkDetails";
import VintedDetails from "./VintedDetails";

const MarketplacesStep = ({
  formData,
  processingImages,
  progress,
  ebayConnected,
  checkingEbay,
  poshmarkConnected,
  checkingPoshmark,
  poshmarkSubCategories,
  vintedConnected,
  checkingVinted,
  vintedMainCategories,
  vintedSubCategories,
  vintedCategoryHistory,
  vintedCurrentCategoryId,
  vintedSelectedCategoryPath,
  vintedLoadingCategories,
  handleMarketplaceToggle,
  handlePoshmarkIntegrate,
  handlePoshmarkCategoryChange,
  handleVintedIntegrate,
  handleVintedCategoryClick,
  handleVintedBack,
  resetVintedCategory,
  handleInputChange,
  handleVariantChange,
}) => {
  return (
    <div className="step-panel">
      {processingImages && (
        <div className="progress-bar-wrapper my-3">
          <div
            className="progress-bar-bg"
            style={{
              width: "100%",
              height: "6px",
              background: "#eee",
              borderRadius: "4px",
            }}
          >
            <div
              className="progress-bar-fill"
              style={{
                width: `${progress}%`,
                height: "100%",
                background: "#6a1b9a",
                borderRadius: "4px",
                transition: "width 0.3s",
              }}
            ></div>
          </div>
          <span style={{ fontSize: "14px", color: "#555" }}>
            {progress}% Processing Images...
          </span>
        </div>
      )}
      <div className="step-header">
        <h2>Select Marketplaces</h2>
        <p>Choose where you want to list your product</p>
      </div>
      <div className="marketplace-grid">
        {availableMarketplaces.map((marketplace) => (
          <div
            key={marketplace.id}
            className={`marketplace-card ${
              formData.selectedMarketplaces.includes(marketplace.id)
                ? "selected"
                : ""
            }`}
          >
            <div
              className="marketplace-select-area"
              onClick={() => handleMarketplaceToggle(marketplace.id)}
            >
              <div className="marketplace-logo">
                <img src={marketplace.logo} alt={marketplace.name} />
              </div>
              <h4>{marketplace.name}</h4>
              <div className="marketplace-check">
                {formData.selectedMarketplaces.includes(marketplace.id)
                  ? "✓"
                  : ""}
              </div>
            </div>
           {marketplace.id === "ebay" && (
  <div className="integration-status ms-2">
    {checkingEbay ? (
      <small className="text-muted">Checking...</small>
    ) : ebayConnected ? (
      <small className="text-success"></small>
    ) : (
      <small className="text-danger"></small>
    )}
  </div>
)}
            {marketplace.id === "poshmark" && (
              <MDBBtn
                size="sm"
                color="light"
                className="integrate-btn"
                onClick={handlePoshmarkIntegrate}
                disabled={checkingPoshmark}
              >
                {checkingPoshmark
                  ? "Checking..."
                  : poshmarkConnected
                    ? "Connected"
                    : "Integrate"}
              </MDBBtn>
            )}
            {marketplace.id === "vinted" && (
              <MDBBtn
                size="sm"
                color="light"
                className="integrate-btn"
                onClick={handleVintedIntegrate}
                disabled={checkingVinted}
              >
                {checkingVinted
                  ? "Checking..."
                  : vintedConnected
                    ? "Connected"
                    : "Integrate"}
              </MDBBtn>
            )}
          </div>
        ))}
        {upcomingMarketplaces.map((marketplace) => (
          <div key={marketplace.id} className="marketplace-card upcoming">
            <div className="marketplace-logo">
              <img
                src={marketplace.logo}
                alt={`${marketplace.name} logo`}
              />
            </div>
            <h4>{marketplace.name}</h4>
            <div className="marketplace-badge">Coming Soon</div>
          </div>
        ))}
      </div>

      {formData.selectedMarketplaces.includes("poshmark") && (
        <PoshmarkDetails
          formData={formData}
          poshmarkConnected={poshmarkConnected}
          poshmarkSubCategories={poshmarkSubCategories}
          handlePoshmarkCategoryChange={handlePoshmarkCategoryChange}
          handleInputChange={handleInputChange}
          handleVariantChange={handleVariantChange}
        />
      )}

      {formData.selectedMarketplaces.includes("vinted") && (
        <VintedDetails
          formData={formData}
          vintedConnected={vintedConnected}
          vintedMainCategories={vintedMainCategories}
          vintedSubCategories={vintedSubCategories}
          vintedCategoryHistory={vintedCategoryHistory}
          vintedCurrentCategoryId={vintedCurrentCategoryId}
          vintedSelectedCategoryPath={vintedSelectedCategoryPath}
          vintedLoadingCategories={vintedLoadingCategories}
          handleVintedCategoryClick={handleVintedCategoryClick}
          handleVintedBack={handleVintedBack}
          resetVintedCategory={resetVintedCategory}
          handleInputChange={handleInputChange}
        />
      )}
    </div>
  );
};

export default MarketplacesStep;

